module.exports = __webpack_public_path__ + "static/media/tv.c01c0d81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/tv.svg
// module id = 552
// module chunks = 0